export default "__VITE_ASSET__DXkzeu5t__"